import { render, staticRenderFns } from "./DesignStudioItemForm.vue?vue&type=template&id=6d12b0e8&scoped=true&"
import script from "./DesignStudioItemForm.vue?vue&type=script&lang=js&"
export * from "./DesignStudioItemForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignStudioItemForm.vue?vue&type=style&index=0&id=6d12b0e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12b0e8",
  null
  
)

export default component.exports